import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  Grid,
  Menu,
  MenuItem,
  Badge,
  Typography,
  IconButton,
  Toolbar,
  Box,
  AppBar,
  Avatar,
} from "@mui/material";
import MoreIcon from '@mui/icons-material/MoreVert';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import { getNotificationCount, getNotificationSeen } from 'redux/actions/UserNotification';
import { getProfile } from 'redux/actions/UserProfile';
import { getSosAlert } from 'redux/actions/UserTrip';
import { getMagicToken } from 'redux/actions/UserLogin';
import {appBarStyle} from './HeaderStyle';
import CommonSosDialog from 'components/commonSosDialog/CommonSosDialog';
import { companyDetails } from 'utils/companyDetails';
import profile from 'assets/images/profileImg.svg'
import { fetchRolesAndPermissions } from 'redux/actions/RolesAndPermissionsAction';
import Notifications from '../Notifications/Notifications';

function Header(props) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [pageName, setPageName] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(null);
  //let tableData = useSelector((state) => state?.userNotificationCount?.userNotificationCount?.data);
  const userProfileData = useSelector((state) => state?.userProfile?.userProfile?.data);
  const sosAlertData = useSelector((state) => state?.userSOSAlert?.userSOSAlert);
  // const role = localStorage.getItem('role');
   const status = localStorage.getItem('status');
   const PendingStatus = status ==='Pending'
  // const filterData = {
  //   id: ''
  // }
  
  useEffect(() => {
    dispatch(getProfile());
    dispatch(fetchRolesAndPermissions())
  }, []);

  useEffect(() => {
    const data = window.location.href;
    const paramsVal = data?.split('/')[3];
    setPageName(paramsVal?.split('?')[0]);
  }, [location]);
  
  const handleOnError = (e) => {
    e.target.src = profile
  }

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isPopoverMenuOpen = Boolean(popoverOpen);

  const handleProfileMenuOpen = () => {
    window.location.replace('/account')
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handlePopoverMenuOpen = (event) => {
    setPopoverOpen(event.currentTarget);
  };
 
  const handlePopoverMenuClose = () => {
    setPopoverOpen(null);
  };
  const onClickSOS = () => {
    dispatch(getSosAlert());
    setOpen(true)
    
  }
  const handleClose = () =>{
    setOpen(false)
  }

  const handleSwitchBtn = () => {
    //API calling for magic token and this magic token
    dispatch(getMagicToken())
  }

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* // TODO: will use for after notification API is added */}
      {/* <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={tableData?.notificationsCount} color="error">
            <img src={notification} alt="notification icon" />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem> */}
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <img className='wh50' src={userProfileData?.avatar?.url && userProfileData?.avatar?.url !== null ? userProfileData?.avatar?.url : profile} alt="profile" onError={handleOnError} />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const popoverMenuId = "primary-switch-account-menu";
  const renderPopoverMenu = (
    <Menu
      anchorEl={popoverOpen}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={popoverMenuId}
      keepMounted
      open={isPopoverMenuOpen}
      onClose={handlePopoverMenuClose}
    >
      <MenuItem
        className="bgWhite"
        onClick={() => handleSwitchBtn()}
      >
        <Avatar
          alt="Admin"
          src={userProfileData?.avatar?.url && userProfileData?.avatar?.url !== null ? userProfileData?.avatar?.url : profile}
          onError={handleOnError}
          className="width50"
        />
        <Typography className="paddingleft10 fw500 colorBlack font12">
          {companyDetails?.companyName} B2B
        </Typography>
      </MenuItem>
    </Menu>
  );

  function generateGreeting(pageName) {
    switch (pageName) {
      case 'dashboard':{
        const currentTime = new Date();
        const hours = currentTime.getHours();
 

        if (hours >= 5 && hours < 12) {
          return "Good Morning";
        } else if (hours >= 12 && hours < 17) {
          return "Good Afternoon";
        } else {
          return "Good Evening";
        }
      }
      case 'liveTracking':
        return 'Live Tracking';
      case 'vendor':
        return 'City Manager';
      case 'subvendor':
        return 'Sub Vendor';
      case 'customer':
        return 'Customer';
      case 'driver':
        return 'Driver';
      case 'feedback':
        return 'Feedback';
      case 'compliance':
        return 'Compliance';
      case 'notification':
        return 'Notification';
      case 'rideTrack':
        return 'Track Trip';
      case 'settings':
        return 'Settings';
      case 'addcomplaince':
        return 'Configuration';
      case 'addfeedback':
          return 'Configuration';
      case 'addcabcategory':
          return 'Configuration';
      case'support':
          return 'Support';
      case'invoice':
          return "Invoice";
      case "reports" :
          return"Report";
      case 'faq' :
          return 'Configuration';
      case 'policy' :
          return 'Policy';
      case 'ratecard' :
          return 'Configuration';
      case 'ratecard-new' : 
          return 'Rate Card New';
      case 'assignvechile' :
        return 'Assign Vehicle';
      case 'assigndriver' :
        return 'Assign Driver';
      case 'assigntrip' :
        return 'Assign Trip';
      case 'coupons' :
        return 'Configuration';
      case 'reports-revenue' :
        return 'Revenue';
      case 'reports-booking' :
        return 'Booking';
      case 'reports-customer' :
        return 'Customer';
      case 'tollCharges' :
        return 'Toll Management';
      case 'serviceableZones' :
        return 'Serviceable Zones';
      case 'complaints' : 
        return 'Tickets';
      case 'coupon-report':
        return 'Coupon Report';
      case 'trip-details-report': 
        return 'Trip Details Report';
      case 'report-generate':
        return 'Generated Reports';
      case 'account':
        return 'Account Settings';
      case 'adminSetting':
        return 'System Settings';
      default:
        return pageName.charAt(0).toUpperCase() + pageName.slice(1) || 'Hello';
    }
  }

  const greeting = generateGreeting(pageName);

  

  return (
    <div>
      <Box>
        <AppBar position="static" style={appBarStyle}>
          <Toolbar>
          <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={props.handelOnlyOnMobile}
              sx={{ mr: 2, display: { sm: 'none', xs:'flex' } }}
            >
              <MenuIcon />
            </IconButton>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="height86"
            >
              <Grid item xs={5}>
                {pageName === 'dashboard' && (
                  <Typography className="colorGrey font14 fontSemi">
                    <p className='marginBlock0'>{`Hi, ${userProfileData?.subRole  || "NA"}`}</p>
                  </Typography>
                )}
                <Typography variant="h6" noWrap component="div">
                  <p
                    className={
                      pageName === 'dashboard'
                        ? 'font20 fontMedium marginBlock0'
                        : 'font20 fontMedium marginBlock'
                    }
                  >
                    {greeting}
                  </p>
                </Typography>
              </Grid>

              <Grid
                container
                item
                xs={7}
                direction="row"
                justifyContent="end"
                alignItems="center"
              >
                <Grid item xs={6}>
                </Grid>

                <Grid item className="vendorIcons justifyEnd">
                  <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                  <Notifications />
                    {/* <IconButton
                      size="large"
                      aria-label="show 17 new notifications"
                      color="inherit"
                      className="filterBtn"
                      onClick={() => {onNotification()}}
                      disabled={PendingStatus? true : role === 'subVendorCompany'? true :false}
                    >
                      <Badge badgeContent={tableData?.notificationsCount} color="error">
                        <img src={notification} alt="notification icon" />
                      </Badge>
                    </IconButton> */}
                    <IconButton
                      size="large"
                      edge="end"
                      aria-label="account of current user"
                      aria-controls={menuId}
                      aria-haspopup="true"
                      color="inherit"
                      className="filterBtn"
                      onClick={handleProfileMenuOpen}
                      disabled={PendingStatus? true : false}
                    >
                      <img className='wh50' src={userProfileData?.avatar?.url && userProfileData?.avatar?.url !== null ? userProfileData?.avatar?.url : profile} alt="profile" onError={handleOnError} />
                    </IconButton>
                  </Box>
                  <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                    <IconButton
                      size="large"
                      aria-label="show more"
                      aria-controls={mobileMenuId}
                      aria-haspopup="true"
                      onClick={handleMobileMenuOpen}
                      color="inherit"
                    >
                      <MoreIcon />
                    </IconButton>
                  </Box>
                  {userProfileData?.companyType === "adminCompany" && (
                    <Box>
                      <IconButton
                        aria-label="show more"
                        aria-controls={popoverMenuId}
                        aria-haspopup="true"
                        onClick={handlePopoverMenuOpen}
                        color="inherit"
                      >
                        <Typography className="pl10 font12">
                        {companyDetails?.companyName} B2C
                        </Typography>
                        {popoverOpen ? (
                          <ExpandMoreRoundedIcon />
                        ) : (
                          <ExpandLessRoundedIcon />
                        )}
                      </IconButton>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
        {renderMenu}
        {renderPopoverMenu}
        {open && 
      <CommonSosDialog 
      open= {open}
      handleClose={handleClose}
      sosAlertData={sosAlertData}
      />
      }
      </Box>
    </div>
  );
}

export default Header;





